import React from 'react';

import { Alert, AlertDescription, AlertTitle } from 'shadcn/components/ui/Alert';
import { Button } from 'shadcn/components/ui/Button';
import { Input } from 'shadcn/components/ui/Input';
import { Label } from 'shadcn/components/ui/Label';

/**
 * @param {Object} props
 * @param {string} [props.errorMessage]
 * @param {boolean} props.isSubmitting
 * @param {string} props.overrideExpirationDateBadgeNumber
 * @param {(value: string) => void} props.onOverrideExpirationDateBadgeNumberChange
 * @param {() => void} props.onShowOverrideEntry
 * @param {boolean} props.showExpirationOverrideEntry
 */
function ExpirationDateOverrideAlert({
    errorMessage,
    isSubmitting,
    onOverrideExpirationDateBadgeNumberChange,
    onShowOverrideEntry,
    overrideExpirationDateBadgeNumber,
    showExpirationOverrideEntry,
}) {
    return (
        <Alert className="mb-4" variant="destructive">
            <AlertTitle>Expiration variance error found</AlertTitle>
            <AlertDescription>
                {errorMessage ? <p className="mb-3">{errorMessage}</p> : null}
                {!showExpirationOverrideEntry ? (
                    <Button disabled={isSubmitting} type="button" variant="outline" onClick={onShowOverrideEntry}>
                        Override
                    </Button>
                ) : (
                    <div className="mt-1 space-y-2">
                        <p>Enter badge number and re-submit</p>
                        <div className="max-w-xs">
                            <Label htmlFor="expiration-override-badge-number">Badge Number</Label>
                            <Input
                                id="expiration-override-badge-number"
                                className="mt-2"
                                disabled={isSubmitting}
                                type="number"
                                value={overrideExpirationDateBadgeNumber}
                                onChange={(event) => onOverrideExpirationDateBadgeNumberChange(event.target.value)}
                                onWheel={(e) => {
                                    e.target.blur();
                                }}
                            />
                        </div>
                    </div>
                )}
            </AlertDescription>
        </Alert>
    );
}

export { ExpirationDateOverrideAlert };
